import { CommonTokens } from './type';

const common: CommonTokens = {
  lineHeightDynamic: 'Line-height-dynamic',
  defaultBorder: 'Border-1',
  iconCirclePadding: 'Padding-4',
  transparent: 'transparent',
};

export default common;
